import React, { useMemo, useCallback, useState, useEffect } from 'react';
import { Card, Col, Form } from 'react-bootstrap';
import { useQuery, useLazyQuery } from '@apollo/client';
import {
  gqlGetCpGroups,
  gqlGetCpSubgroups,
  gqlGetCpSubsubgroups,
  gqlGetCpGroupsFlatview,
} from './graphql';
import { FlexRow, FormRow, TableInMem, ButtonExport, useWhyDidYouUpdate } from 'motion-components';
import { useRootStore } from 'store';
import { faEye, faFile } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { generatePath, useHistory } from 'react-router';
import { getRouteByName } from 'app/routes';
import { useTranslation } from 'react-i18next';
import LoadingOverlay from '@achmadk/react-loading-overlay';
import { useLocation } from 'react-router-dom';
import { useHandleError } from 'shared-pages/services';

/* ----------- Page ------------------ */
export const CpGroupsPage = () => {
  const { appStore } = useRootStore();
  const { handleGraphqlError } = useHandleError('cpgroups');
  const { t } = useTranslation();
  /* ----------------- Route State -------------------------- */
  const location = useLocation();
  const history = useHistory();

  const [selectedRadio, setSelectedRadio] = useState(
    (location as any)?.state?.selectedRadio ?? null,
  );
  const [selectedSubRadio, setSelectedSubRadio] = useState(
    (location as any)?.state?.selectedSubRadio ?? null,
  );
  const [visible, setVisible] = useState((location as any)?.state?.selectedSubRadio ? true : false);

  const {
    loading,
    data: rawData,
    error,
    refetch,
  } = useQuery(gqlGetCpGroups, {
    fetchPolicy: 'network-only',
    variables: {
      order: 'name ASC',
    },
  });
  const dataGroups = rawData?.getCpGroups?.data;

  const [getSub, { data: dataSub, error: errorSub, refetch: refetchSub }] = useLazyQuery(
    gqlGetCpSubgroups,
    {
      fetchPolicy: 'network-only',
    },
  );
  const dataSubGroups = dataSub?.getCpSubgroups?.data;

  const [getSubSub, { data: dataSubSub, error: errorSubSub }] = useLazyQuery(gqlGetCpSubsubgroups, {
    fetchPolicy: 'network-only',
  });
  const dataSubSubGroups = dataSubSub?.getCpSubsubgroups?.data;

  useEffect(() => {
    if (selectedRadio !== null) {
      getSub({
        variables: { order: 'name ASC', where: JSON.stringify({ groupId: selectedRadio }) },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- getSub αλλάζει reference σε κάθε render
  }, [selectedRadio]);

  useEffect(() => {
    if (selectedSubRadio !== null) {
      getSubSub({
        variables: { order: 'name ASC', where: JSON.stringify({ subgroupId: selectedSubRadio }) },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- getSubSub αλλάζει reference σε κάθε render
  }, [selectedSubRadio]);

  const handleGroupChange = (id) => {
    console.log('Group Changed', id);
    setSelectedRadio(id);
    setSelectedSubRadio(null);

    setVisible(false);
    const state = {
      ...(location as any).state,
      selectedRadio: id,
      selectedSubRadio: null,
    };
    history.replace(location.pathname, state);
  };

  const handleSubGroupChange = (id) => {
    setSelectedSubRadio(id);
    const state = {
      ...(location as any).state,
      selectedSubRadio: id,
    };
    history.replace(location.pathname, state);
    setVisible(true);
  };

  const tablePageSize = appStore.pageSize;
  const tablePageSize2 = appStore.pageSize;
  const tablePageSize3 = appStore.pageSize;

  const [initPageIndex, setInitPageIndex] = useState((location as any)?.state?.pageIndex ?? 0);
  const [queryParams, setQueryParams] = useState({
    offset: tablePageSize * initPageIndex,
    limit: tablePageSize,
    order: 'name ASC',
  });

  const [initPageIndex2, setInitPageIndex2] = useState((location as any)?.state?.pageIndex2 ?? 0);
  const [queryParams2, setQueryParams2] = useState({
    offset: tablePageSize2 * initPageIndex2,
    limit: tablePageSize2,
    order: 'name ASC',
  });

  const [initPageIndex3, setInitPageIndex3] = useState((location as any)?.state?.pageIndex3 ?? 0);
  const [queryParams3, setQueryParams3] = useState({
    offset: tablePageSize3 * initPageIndex3,
    limit: tablePageSize3,
    order: 'name ASC',
  });

  /* handle Pagination */
  const gridPageChanged = useCallback(
    (pageIndex, pageSize: number) => {
      console.log('gridPageChanged', pageIndex, pageSize);
      setInitPageIndex(pageIndex);
      const newQueryParams = { ...queryParams, offset: pageSize * pageIndex, limit: pageSize };
      setQueryParams(newQueryParams);
      refetch(newQueryParams);

      // Ενημέρωσε το State του Route
      const state = {
        ...(location as any).state,
        pageIndex,
      };
      history.replace(location.pathname, state);
    },
    [history, location.pathname, location.state, queryParams, refetch],
  );

  const gridPageChanged2 = useCallback(
    (pageIndex2, pageSize2: number) => {
      console.log('gridPageChanged', pageIndex2, pageSize2);
      setInitPageIndex2(pageIndex2);
      const newQueryParams2 = { ...queryParams2, offset: pageSize2 * pageIndex2, limit: pageSize2 };
      setQueryParams2(newQueryParams2);
      refetchSub(newQueryParams2);

      // Ενημέρωσε το State του Route
      const state = {
        ...(location as any).state,
        pageIndex2,
      };
      history.replace(location.pathname, state);
    },
    [history, location.pathname, location.state, queryParams2, refetchSub],
  );

  const gridPageChanged3 = useCallback(
    (pageIndex3, pageSize3: number) => {
      console.log('gridPageChanged', pageIndex3, pageSize3);
      setInitPageIndex3(pageIndex3);
      const newQueryParams3 = { ...queryParams3, offset: pageSize3 * pageIndex3, limit: pageSize3 };
      setQueryParams3(newQueryParams3);
      refetchSub(newQueryParams3);

      // Ενημέρωσε το State του Route
      const state = {
        ...(location as any).state,
        pageIndex3,
      };
      history.replace(location.pathname, state);
    },
    [history, location.pathname, location.state, queryParams3, refetchSub],
  );

  /**
   *  * ΠΑΤΗΘΗΚΕ Η NEA ΕΓΓΡΑΦΗ (Callback)
   */
  const handleCreateNewGroup = useCallback(() => {
    history.push(generatePath(getRouteByName('CpGroup'), { id: -1 }), {
      state: {
        pathname: location.pathname,
        ...(location as any).state,
      },
    });
  }, [history, location.pathname, location.state]);
  const handleCreateNewSubGroup = useCallback(() => {
    history.push(generatePath(getRouteByName('CpSubGroup'), { id: -1, selected: selectedRadio }), {
      state: {
        pathname: location.pathname,
        ...(location as any).state,
      },
    });
  }, [history, location.pathname, location.state, selectedRadio]);
  const handleCreateNewSubSubGroup = useCallback(() => {
    history.push(
      generatePath(getRouteByName('CpSubSubGroup'), {
        id: -1,
        selected: selectedRadio,
        selectedSub: selectedSubRadio,
      }),
      {
        state: {
          pathname: location.pathname,
          ...(location as any).state,
        },
      },
    );
  }, [history, location.pathname, location.state, selectedRadio, selectedSubRadio]);

  useWhyDidYouUpdate('CpGroupsPage', {
    selectedRadio,
    dataSubGroups,
    dataSubSubGroups,
    selectedSubRadio,
    location,
  });

  function useGetCpGroupsFlatview() {
    return useLazyQuery(gqlGetCpGroupsFlatview);
    //return [null, { loading: null, data: null }];
  }

  const handleExport = useCallback(async () => {
    // await exportXlsModal({
    //   getLazyQuery: useGetCpGroupsFlatview,
    //   filterVariables: { order: 'groupName ASC, subgroupName ASC, subsubgroupName ASC' },
    //   tableName: 'cp_groups_flatview',
    //   columnsDef: [
    //     { fieldName: 'groupName', fieldTitle: 'Κατηγορία', fieldType: 'TEXT' },
    //     { fieldName: 'subgroupName', fieldTitle: 'Υποκατηγορία', fieldType: 'TEXT' },
    //     { fieldName: 'subsubgroupName', fieldTitle: 'Υπο-υποκατηγορία', fieldType: 'TEXT' },
    //   ],
    // });
  }, []);

  if (error) {
    handleGraphqlError('query-get', error);
    return <h3 className="text-center">{error.message}</h3>;
  } else if (errorSub) {
    handleGraphqlError('query-getSub', errorSub);
    return <h3 className="text-center">{errorSub.message}</h3>;
  } else if (errorSubSub) {
    handleGraphqlError('query-getSubSub', errorSubSub);
    return <h3 className="text-center">{errorSubSub.message}</h3>;
  } else {
    return (
      <Card className="shadow">
        <Card.Header>
          <FlexRow>
            <Card.Title className="m-0">{t('Κατηγορίες')}</Card.Title>
          </FlexRow>
        </Card.Header>
        <Card.Body className="nopadding">
          <LoadingOverlay
            active={loading && !rawData}
            spinner
            text={t('Παρακαλώ περιμένετε...')}
          >
            {rawData ? (
              <FormRow>
                <Col>
                  <DataGrid
                    data={dataGroups}
                    handleCreateNew={handleCreateNewGroup}
                    selectedRadio={selectedRadio}
                    setSelectedRadio={handleGroupChange}
                    initPageIndex={initPageIndex}
                    onPageChange={gridPageChanged}
                  />
                </Col>
                <Col>
                  {dataSubGroups ? (
                    <DataGridSub
                      data={dataSubGroups}
                      handleCreateNew={handleCreateNewSubGroup}
                      selectedRadio={selectedSubRadio}
                      setSelectedRadio={handleSubGroupChange}
                      initPageIndex2={initPageIndex2}
                      onPageChange2={gridPageChanged2}
                    />
                  ) : (
                    <div style={{ height: '200px' }}></div>
                  )}
                </Col>
                <Col>
                  {dataSubSubGroups && visible === true ? (
                    <DataGridSubSub
                      data={dataSubSubGroups}
                      handleCreateNew={handleCreateNewSubSubGroup}
                      initPageIndex3={initPageIndex3}
                      onPageChange3={gridPageChanged3}
                    />
                  ) : (
                    <div style={{ height: '200px' }}></div>
                  )}
                </Col>
              </FormRow>
            ) : (
              <div style={{ height: '200px' }}></div>
            )}
          </LoadingOverlay>
        </Card.Body>
        <Card.Footer>
          <ButtonExport onClick={handleExport} />{' '}
        </Card.Footer>
      </Card>
    );
  }
};

/* ----------- Grid ------------------ */

const DataGrid = ({
  data,
  selectedRadio,
  setSelectedRadio,
  handleCreateNew,
  initPageIndex,
  onPageChange,
}) => {
  //console.log(props.dataX);
  const location = useLocation();
  const history = useHistory();
  const { appStore } = useRootStore();
  const { t, i18n } = useTranslation();

  const rowClicked = useCallback(
    (row) => {
      history.push(generatePath(getRouteByName('CpGroup'), { id: row.id }), {
        state: {
          // pathname: location.pathname,
          // ...(location as any).state,
        },
      });
    },
    [history, location.pathname, location.state],
  );
  const columns = useMemo(
    () => [
      {
        // ΚΟΛΩΝΑ ΜΕ RedEye και Click handler
        id: 'select',
        Header: () => <FontAwesomeIcon icon={faFile} />,
        Cell: ({ row }) => (
          <div
            className="text-center"
            style={{ cursor: 'pointer' }}
            onClick={() => {
              rowClicked(row.original);
            }}
          >
            <FontAwesomeIcon icon={faEye} />
          </div>
        ),
      },
      { Header: 'Κατηγορία', accessor: 'name' },
      {
        /* ΚΟΛΩΝΑ ΜΕ Radio για επιλογή ΕΝΟΣ */
        id: 'selection',
        Header: () => <div className="text-center">{t('Επιλογή')}</div>,
        accessor: 'selected',
        Cell: ({ row }) => (
          <div className="text-center">
            <Form.Check
              type="radio"
              id={`custom-${row.original.id}`}
              label={``}
              value={row.original.id}
              checked={selectedRadio === row.original.id}
              onChange={() => setSelectedRadio(row.original.id)}
            />
          </div>
        ),
        disableSorting: true,
      },
    ],
    [rowClicked, selectedRadio, setSelectedRadio],
  );
  return (
    <TableInMem
      //onRefresh={() => refetch()}
      /* onExport={handleExport} */
      appStore={appStore}
      onPageChange={onPageChange}
      initPageIndex={initPageIndex}
      columns={columns}
      data={data}
      onNew={handleCreateNew}
    />
  );
};

const DataGridSub = ({
  data,
  selectedRadio,
  setSelectedRadio,
  handleCreateNew,
  initPageIndex2,
  onPageChange2,
}) => {
  //console.log(props.dataX);
  const { appStore } = useRootStore();
  const { t, i18n } = useTranslation();

  const location = useLocation();
  const history = useHistory();
  const rowClicked = useCallback(
    (row) => {
      history.push(
        generatePath(getRouteByName('CpSubGroup'), { id: row.id, selected: row.groupId }),
        {
          state: {
            // pathname: location.pathname,
            // ...(location as any).state,
          },
        },
      );
    },
    [history, location.pathname, location.state],
  );
  const columns = useMemo(
    () => [
      {
        // ΚΟΛΩΝΑ ΜΕ RedEye και Click handler
        id: 'select',
        Header: () => <FontAwesomeIcon icon={faFile} />,
        Cell: ({ row }) => (
          <div
            className="text-center"
            style={{ cursor: 'pointer' }}
            onClick={() => {
              rowClicked(row.original);
            }}
          >
            <FontAwesomeIcon icon={faEye} />
          </div>
        ),
      },
      { Header: 'Υποκατηγορία', accessor: 'name' },
      {
        /* ΚΟΛΩΝΑ ΜΕ Radio για επιλογή ΕΝΟΣ */
        id: 'selection',
        Header: () => <div className="text-center">{t('Επιλογή')}</div>,
        accessor: 'selected',
        Cell: ({ row }) => (
          <div className="text-center">
            <Form.Check
              type="radio"
              id={`custom2-${row.original.id}`}
              label={``}
              value={row.original.id}
              checked={selectedRadio === row.original.id}
              onChange={() => setSelectedRadio(row.original.id)}
            />
          </div>
        ),
        disableSorting: true,
      },
    ],
    [rowClicked, selectedRadio, setSelectedRadio],
  );
  return (
    <TableInMem
      //onRefresh={() => refetch()}
      //onExport={handleExport}
      appStore={appStore}
      columns={columns}
      data={data}
      onNew={handleCreateNew}
      onPageChange={onPageChange2}
      initPageIndex={initPageIndex2}
    />
  );
};

const DataGridSubSub = ({ data, handleCreateNew, initPageIndex3, onPageChange3 }) => {
  const { appStore } = useRootStore();

  const location = useLocation();
  const history = useHistory();
  const rowClicked = useCallback(
    (row) => {
      history.push(
        generatePath(getRouteByName('CpSubSubGroup'), {
          id: row.id,
          selected: row.cpSubgroup.groupId,
          selectedSub: row.subgroupId,
        }),
        {
          state: {
            // pathname: location.pathname,
            // ...(location as any).state,
          },
        },
      );
    },
    [history, location.pathname, location.state],
  );
  const columns = useMemo(
    () => [
      {
        // ΚΟΛΩΝΑ ΜΕ RedEye και Click handler
        id: 'select',
        Header: () => <FontAwesomeIcon icon={faFile} />,
        Cell: ({ row }) => (
          <div
            className="text-center"
            style={{ cursor: 'pointer' }}
            onClick={() => {
              rowClicked(row.original);
            }}
          >
            <FontAwesomeIcon icon={faEye} />
          </div>
        ),
      },
      { Header: 'Υπο-υποκατηγορία', accessor: 'name' },
    ],
    [rowClicked],
  );
  return (
    <TableInMem
      //onRefresh={() => refetch()}
      //onExport={handleExport}
      appStore={appStore}
      columns={columns}
      data={data}
      onPageChange={onPageChange3}
      initPageIndex={initPageIndex3}
      onNew={handleCreateNew}
    />
  );
};
